import * as React from "react";



class Label extends React.Component<any, any> {
    constructor(props: any){
        super(props);
        this.state = { showErrors: false };
    }
    public render(){
        const { showErrors, ...others } = this.props;
        const errorClass = this.props.showErrors ? 'error' : 'hidden';
        return (<label {...others}>
            {this.props.children}
            <span className={errorClass}>{this.props.error}</span>
        </label>)
    }
}

export default Label;


// WEBPACK FOOTER //
// ./src/checkout/fields/Label.tsx